(() => {
  let count = 0;
  const update = cart => {
    count = cart.items && window.OnyraPackaging
      ? window.OnyraPackaging.promotionCount(cart)
      : Math.max(0, Number(cart.item_count) || 0);
    document.querySelectorAll('[data-onyra-cart-count]').forEach(node => { node.textContent = count; });
    if (Number.isFinite(cart.original_total_price)) {
      const amount = window.theme?.Currency?.formatMoney
        ? window.theme.Currency.formatMoney(cart.original_total_price, window.theme.settings.moneyFormat)
        : new Intl.NumberFormat('el-GR', { style: 'currency', currency: cart.currency || 'EUR' }).format(cart.original_total_price / 100);
      document.querySelectorAll('[data-onyra-original]').forEach(node => { node.innerHTML = amount; });
    }
    document.querySelectorAll('[data-onyra-tiers]').forEach(node => {
      let message;
      if (count < 2) {
        message = node.dataset.messageStart;
      } else if (count === 2) {
        message = node.dataset.messageShipping;
      } else if (count === 3) {
        message = node.dataset.messageTen;
      } else if (count === 4) {
        message = node.dataset.messageFifteen;
      } else {
        message = node.dataset.messageTwenty;
      }
      const messageNode = node.querySelector('[data-tier-message]');
      if (messageNode) messageNode.textContent = message;
      const progress = count === 0 ? 0 : count === 1 ? 6.25 : Math.min(100, (count - 1) * 25);
      node.style.setProperty('--tier-progress', `${progress}%`);
      node.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', Math.min(count, 5));
      node.querySelectorAll('[data-tier]').forEach(step => step.classList.toggle('is-earned', count >= Number(step.dataset.tier)));
    });
  };
  let requestVersion = 0;
  const refresh = async () => {
    const version = ++requestVersion;
    try {
      const response = await fetch(window.theme?.routes?.cart || '/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (response.ok) { const cart = await response.json(); if (version === requestVersion) update(cart); }
    } catch (_) {}
  };
  document.addEventListener('cart:updated', event => { if (event.detail?.cart) { requestVersion++; update(event.detail.cart); } });
  document.addEventListener('ajaxProduct:added', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-size-open]');
    if (opener) document.getElementById(opener.dataset.sizeOpen)?.showModal();
    const closer = event.target.closest('[data-size-close]');
    if (closer) closer.closest('dialog')?.close();
  });
  document.addEventListener('DOMContentLoaded', () => {
    update({ item_count: Number(document.querySelector('[data-onyra-tiers]')?.dataset.count) || 0 });
    refresh();
  });
})();
